import React from 'react';

const WhiteBackground = ({ children }) => {
     return (
          <div className='white-bg'>{ children }</div>
     )
};

export default WhiteBackground;